import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import { useAuth } from '../../Common/Configurations/AuthContext';

const initialFieldValues = {
  customerName: "",
  phoneNumber: "",
  email: "",
};

const AddCustomerModal = ({ show, onHide, onCustomerAdded }) => {
    const { user } = useAuth();
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [btnLoading, setBtnLoading] = useState(false);

    const validate = () => {
        let temp = {};
        const namePattern = /^[a-zA-Z\s.'-]+$/;
        const emailPattern = /@/;
        const phonePattern = /^\d+$/;

        temp.customerName = values.customerName !== "" && namePattern.test(values.customerName) && !emailPattern.test(values.customerName) && !phonePattern.test(values.customerName.replace(/\s/g, ""));
        temp.phoneNumber = /^\d{10,15}$/.test(values.phoneNumber);
        temp.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email);

        setErrors(temp);
        return Object.values(temp).every(x => x === true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };

    const resetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
        onHide();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnLoading(true);
            const formData = {
                ...values,
                customerId: "00000000-0000-0000-0000-000000000000",
                companyId: user?.cid,
            };
            try {
                await apiService.create(config.CREATECUSTOMER, formData);
                onCustomerAdded(); // This tells the parent to refresh its list
                resetForm();
            } catch (error) {
                // apiService already shows a toast on error
            } finally {
                setBtnLoading(false);
            }
        }
    };

    const applyErrorClass = (field) => (field in errors && errors[field] === false ? " is-invalid" : "");

    return (
        <Modal show={show} onHide={resetForm} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add New Customer</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit} noValidate>
                    <div className="mb-3">
                        <label htmlFor="customerName" className="form-label">Customer Name</label>
                        <input type="text" maxLength={45} value={values.customerName} name="customerName" onChange={handleInputChange} className={`form-control${applyErrorClass("customerName")}`} placeholder="Enter Customer Name" />
                        {errors.customerName === false && <div className="invalid-feedback">{values.customerName === "" ? "Please enter customer name" : "Please enter a valid name"}</div>}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                        <input type="tel" value={values.phoneNumber} name="phoneNumber" onChange={handleInputChange} className={`form-control${applyErrorClass("phoneNumber")}`} placeholder="Enter Phone Number" maxLength={15} />
                        {errors.phoneNumber === false && <div className="invalid-feedback">{values.phoneNumber === "" ? "Please enter phone number" : "Please enter a valid phone number (10-15 digits)"}</div>}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input type="email" maxLength={45} value={values.email} name="email" onChange={handleInputChange} className={`form-control${applyErrorClass("email")}`} placeholder="Enter Email" />
                        {errors.email === false && <div className="invalid-feedback">{values.email === "" ? "Please enter email" : "Please enter a valid email address"}</div>}
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={resetForm}>Cancel</Button>
                <Button variant="primary" onClick={handleSubmit} disabled={btnLoading}>
                    {btnLoading ? "Saving..." : "Save Customer"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddCustomerModal;